import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {Link} from "react-router";
import { NotificationManager } from 'react-notifications';
import moment from 'moment';

import UserRoles from "../../../../../common/src/enums/UserRoles";
import {ROUTE_RACES, ROUTE_RACE, ROUTE_CLUB} from '../../../constants/routeconstants';
import * as AdminActions from "../../../actions/admin";
import * as RaceActions from "../../../actions/race";

import { confirm } from '../../../utils/confirmDialog';
import {nullToBlank, CompressList, isDefined} from '../../../../../common/src/util/lib';
import config from "../../../../../server/src/config";

import { getRegi } from  "../../../../../common/src/util/lib";

class RacesPage extends React.Component {

    static getId() {
        return ROUTE_RACES;
    }

    static getAllowedRoles() {
        return [UserRoles.MAIN_ADMIN, UserRoles.SECTION_ADMIN, UserRoles.CLUB_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            initialized: false,
        }
    }

    componentDidMount() {
        this.props.dispatch(RaceActions.getRaces());
        this.props.dispatch(AdminActions.getListItems('station'));
    }

    render() {
        const week = isDefined(this.props.location.query.week) && /^[0-9]{1,2}$/.test(this.props.location.query.week) ? Number(this.props.location.query.week) : moment(new Date()).isoWeek();
        let raceWeek = null;
        let raceId = null;
        const result = this.props.race.isRacesRead ? <div>
            <div className="sub-page-title">
                <h2>Kapflyvninger</h2>
            </div>
            <div className="sub-page-content">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th scope="row">Uge</th>
                            <th>Farvekode</th>
                            <th>Regi</th>
                            <th>LMU</th>
                            {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <th>Grupper</th> : null}
                            {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <th>Sektioner</th> : null}
                            <th>Station</th>
                            <th>Navn</th>
                            <th>Slipdato</th>
                            <th>Sliptid</th>
                            <th>Duer</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.race.races.sort((r1, r2) => {
                            if (r1.Uge < r2.Uge) return -1;
                            if (r1.Uge > r2.Uge) return 1;
                            if (r1.Farvekode < r2.Farvekode) return -1;
                            if (r1.Farvekode > r2.Farvekode) return 1;
                            if (nullToBlank(r1.Sektion) < nullToBlank(r2.Sektion)) return -1;
                            if (nullToBlank(r1.Sektion) > nullToBlank(r2.Sektion)) return 1;
                            if (nullToBlank(r1.Sektionsgrupper) < nullToBlank(r2.Sektionsgrupper)) return -1;
                            if (nullToBlank(r1.Sektionsgrupper) > nullToBlank(r2.Sektionsgrupper)) return 1;
                            if (nullToBlank(r1.Sektioner) < nullToBlank(r2.Sektioner)) return -1;
                            if (nullToBlank(r1.Sektioner) > nullToBlank(r2.Sektioner)) return 1;
                            return 0;
                        }).toArray().map(race => {
                            if (raceWeek === null || race.Uge <= week) {
                                raceWeek = race.Uge;
                                raceId = race.Nr;
                            }
                            const kfk = race.Farvekode.substr(0, 2);
                            const sections = CompressList(race.Sektioner);
                            const groups = CompressList(race.Sektionsgrupper);
                            const station = this.props.admin.stations.get(race.Station);
                            return <tr key={race.Nr} id={'row-' + race.Nr} onDoubleClick={() => {
                                this.props.dispatch(push(ROUTE_RACE.replace(':raceNo', race.Nr).replace(':subpage', 'general').replace(':mode', 'view')));
                            }}>
                                <th scope="row">{race.Uge}</th>
                                <td>{race.Farvekode}</td>
                                <td>{kfk >= '97' || kfk < '88' ? 'Privat' : (kfk >= '95' && kfk <= '96' ? 'Sektion' : 'DdB')}</td>
                                <td>{race.LMU}</td>
                                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>{groups.items.join(',')}</td> : null}
                                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>{sections.items.join(',')}</td> : null}
                                <td>{race.Station}</td>
                                <td>{station ? station.Navn : null}</td>
                                <td>{race.SlipDato === null ? null : moment(race.SlipDato).format(config.formats.dateFormat)}</td>
                                <td>{race.Sliptid}</td>
                                <td>{race.AntalDuer}</td>
                                <td>
                                    <Link to={ROUTE_RACE.replace(':raceNo', race.Nr).replace(':subpage', 'general').replace(':mode', 'view')} title="Vis detaljer">
                                        <i className="fa fa-file-text-o"/>
                                    </Link>
                                    <Link to={(this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && getRegi(kfk) === 'DdB') ? '' : ROUTE_RACE.replace(':raceNo', race.Nr).replace(':subpage', 'general').replace(':mode', 'edit')} title="Rediger kapflyvning">
                                        <i className={"fa fa-pencil" + ((this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && getRegi(kfk) === 'DdB') ? ' disabled' : '')}/>
                                    </Link>
                                    <i className={"fa fa-trash " + ((this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && getRegi(kfk) === 'DdB') || (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id && (getRegi(kfk) !== 'Privat') || race.Sektion !== null) ? 'disabled' : 'pointer clickable')} title="Slet kapflyvning" disabled={true} onClick={() => {
                                        if ((this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && getRegi(kfk) === 'DdB') || (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id && getRegi(kfk) !== 'Privat')) return;
                                        confirm("Slet", <span>Ønsker du at slette kapflyvning <b>{race.Farvekode}</b> i uge <b>{race.Uge}</b>{race.Sektion === null ? '' : <span>, Sektion {race.Sektion}</span>}{groups.items.length === 0 ? '' : <span>, Gruppe {groups.items.join(',')}</span>}{sections.items.length === 0 ? '' : <span>, Sektion {sections.items.join(',')}</span>}?</span>, () => {
                                            this.props.dispatch(RaceActions.deleteRace(race.Nr, () => {
                                                NotificationManager.success("Kapflyvning " + race.Farvekode + " i uge " + race.Uge + " er slettet.", "Sletning", 4000);
                                            }));
                                        });
                                    }}/>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
            <div className="sub-page-actions">
                <Link className="btn-primary" to={ROUTE_RACE.replace(':raceNo', 'new').replace(':subpage', 'general').replace(':mode', 'create')} title="Opret ny kapflyvning">
                    Ny
                </Link>
            </div>
        </div> : null;

        // Scroll to relevant week.
        if (!this.state.initialized && raceId !== null) setTimeout(function () {
            const currentRow = document.getElementById("row-" + raceId);
            currentRow.scrollIntoView(false);
            this.setState({initialized: true});
            this.props.dispatch(push(ROUTE_RACES));
        }.bind(this));

        return result;
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
    },
    admin: {
        stations: state.admin.stations,
    },
    race: {
        isRacesRead: state.race.isRacesRead,
        races: state.race.races
    }
});

export default connect(mapStateToProps)(RacesPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/race/RacesPage.js